import { AgentDef } from "../../apis/mgmt/api";
import { EditableProps } from "../common/Editable";
import { Modal } from "../common/Modal";
import { ToggleableProps } from "../common/Toggleable";
import { AgentDefEditable } from "./AgentDefEditable";


export const AgentDefEditableModal = function (
    props: EditableProps<AgentDef> & {
        toggle: ToggleableProps
    }
) {
    const action = props.data?.id? 'Editando' : 'Nuevo';

    return (
        <Modal title={`${action} agente`} toggle={props.toggle}>
            <AgentDefEditable {...props} />
        </Modal>
    );
};
